import type { AppLayoutKind } from "@ui/layouts/layoutProvider";

/**
 * Where "start a new question" goes from a chat in each app: a page that
 * picks up the stashed prompt. Undefined where there is none, as the
 * consumer home page (`/`) doesn't read the stash and would drop the clips.
 */
export function askPageForAppKind(
	kind: AppLayoutKind,
	projectId?: string,
): string | undefined {
	switch (kind) {
		case "studio":
			return "/studio/ask-a-question";
		case "labs":
			return projectId
				? `/projects/${projectId}/ask-a-question`
				: "/ask-a-question";
		case "roster":
			return "/roster/ask";
		default:
			return undefined;
	}
}
